export const TABS = {
    DETAILS: "table",
    ADMIN: "delete-form",
    UPDATE: "form",
    PREFERENCES: "subscriptions",
    EMPLOYMENT: "employee-status-table"
};

export const FIELD_TYPE_LABELS = {
    EMAIL: "Email",
    PHONE_NO: "Phone Number",
    LOYALTY_ID: "Loyalty ID"
};

const LOYALTY_ID_PREFIXES = ["424", "525", "535", "545"];

const EMPLOYEE_WARNINGS = [
    ["loyaltyIdVerification", "LoyaltyId does not match."],
    ["emailVerification", "Email not matched, Please verify in workday."],
    ["phoneVerification", "Phone not matched, Please verify in workday."]
];

const UNLIFTABLE_REASON = /cannot be lifted/i;

const isLoyaltyId = (digits) =>
    (digits.length === 11 || digits.length === 12) &&
    LOYALTY_ID_PREFIXES.some(prefix => digits.startsWith(prefix));

const isPhoneNumber = (digits) =>
    digits.length === 10 || (digits.length === 11 && digits.startsWith("1"));

export function detectFieldType(rawValue) {
    const value = (rawValue ?? "").trim();
    if (!value) {
        return "";
    }

    if (/[a-zA-Z]/.test(value) && value.includes("@")) {
        return "EMAIL";
    }

    const digits = value.replaceAll(/\D/g, "");

    if (isLoyaltyId(digits)) {
        return "LOYALTY_ID";
    }

    if (isPhoneNumber(digits)) {
        return "PHONE_NO";
    }

    return "";
}

export const hasUnliftableReason = (reasons) =>
    (reasons ?? []).some(reason => UNLIFTABLE_REASON.test(reason));

// Unliftable suppressions can only be fixed by correcting the email (Update tab); others can be unsuppressed (Admin tab).
export const getSuppressionTab = (reasons) =>
    hasUnliftableReason(reasons) ? TABS.UPDATE : TABS.ADMIN;

export const getEmployeeWarnings = (employeeStatus) =>
    EMPLOYEE_WARNINGS
        .filter(([key]) => employeeStatus?.[key] === false)
        .map(([, message]) => message);

export const tabPaneClass = (activeTab, tab) =>
    `tab-pane fade ${activeTab === tab ? "show active" : ""}`;
